/* ••[1]••••••••••••••••••••••••• VanillaPollsProvider.ts •••••••••••••••••••••••••••••• */

import VanillaProvider from "./VanillaProvider";
import { VanillaPoll } from "./../../../interfaces/VanillaApi";
import FetchSettings from "../../../interfaces/FetchSettings";

export default class VanillaPollsProvider extends VanillaProvider {
  public async getPolls(): Promise<Array<VanillaPoll | null>> {
    const settings: FetchSettings = {
      method: "GET",
    };
    const polls: Array<VanillaPoll> = await this.request(
      this.baseUrl + "polls?",
      settings
    );
    return polls;
  }

  public async answerPoll(pollId: number, answerId: number, userId: number) {
    const body = {
      pollOptionID: answerId,
      userID: userId,
    };
    const settings: FetchSettings = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "x-requested-with": "vanilla",
      },
    };
    try {
      const response: Promise<null> = await this.request(
        this.baseUrl + `polls/${pollId}/vote`,
        settings
      );
      return response;
    } catch (error) {
      console.error(error);
      return {
        success: false,
        msg: "Server didn't respond.",
      };
    }
  }

  public async createPoll(
    pollName: string,
    pollCategoryId: number,
    pollOptions?: object[]
  ): Promise<VanillaPoll | null> {
    const body = {
      name: pollName,
      categoryID: pollCategoryId,
      body: "Did you watch the replay",
      pollOption: pollOptions || [{ body: "yes" }, { body: "no" }],
    };
    const settings: FetchSettings = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "x-requested-with": "vanilla",
      },
    };
    try {
      const response: Promise<null> = await this.request(
        this.baseUrl + `polls`,
        settings
      );
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
